import CTAButton from '../CTAButton';
import InfoCard from './InfoCard';

/**
 * CardColumn Component
 * Cards with icon, title, and description + optional section title
 * @param {Array} cards - Array of card objects {icon (react component), title, description}
 * @param {number} cols - Number of columns
 * @param {string} title - Optional section title
 * @param {string} subtitle - Optional subtitle
 * @param {string} description - Optional section description
 * @param {function} ctaOnClick - Optional CTA button click handler
 * @param {string} ctaText - Optional CTA button text
 */
export default function CardColumn({ 
  cards = [], 
  cols = 3, 
  title = '',
  subtitle = '',
  description = '',
  ctaOnClick = null,
  ctaText = 'Get Started',
  className = '' 
}) {
  const colsMap = {
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
  };

  return (
    <div className={className}>
      {(title || subtitle || description) && (
        <div className='mb-16 text-center max-w-3xl mx-auto'>
          {subtitle && (
            <p className='text-[#456EF2] font-montserrat font-semibold text-sm uppercase tracking-wide mb-3'>
              {subtitle}
            </p>
          )}
          {title && (
            <h2 className='font-montserrat font-bold text-5xl md:text-6xl mb-6 text-slate-900'>
              {title}
            </h2>
          )}
          {description && (
            <p className='text-slate-600 text-xl leading-relaxed'>
              {description}
            </p>
          )}
        </div>
      )}

      <div className={`grid ${colsMap[cols] || colsMap[3]} gap-6 mb-12`}>
        {cards.map((card, index) => (
          <InfoCard
            key={index}
            icon={card.icon}
            title={card.title}
            iconSize="lg"
          >
            {card.description}
          </InfoCard>
        ))}
      </div>
      {ctaOnClick && (
        <div className='flex justify-center'>
          <CTAButton onClick={ctaOnClick}>{ctaText}</CTAButton>
        </div>
      )}
    </div>
  );
}
